var map = {
	"./icon-arrow-down.svg": 21,
	"./icon-arrow-left.svg": 22,
	"./icon-arrow-right.svg": 23,
	"./icon-arrow-up-large.svg": 24,
	"./icon-arrow-up.svg": 25,
	"./icon-carret-nav.svg": 26,
	"./icon-chevron-right.svg": 27,
	"./icon-close.svg": 28,
	"./icon-email.svg": 29,
	"./icon-facebook.svg": 30,
	"./icon-hart.svg": 31,
	"./icon-instagram.svg": 32,
	"./icon-linkedin.svg": 33,
	"./icon-mail.svg": 34,
	"./icon-marker.svg": 35,
	"./icon-menu.svg": 36,
	"./icon-messenger.svg": 37,
	"./icon-phone.svg": 38,
	"./icon-pinterest.svg": 39,
	"./icon-read-more.svg": 40,
	"./icon-search.svg": 41,
	"./icon-skype.svg": 42,
	"./icon-snapchat.svg": 43,
	"./icon-star.svg": 44,
	"./icon-telegram.svg": 45,
	"./icon-tiktok.svg": 46,
	"./icon-twitter.svg": 47,
	"./icon-vimeo.svg": 48,
	"./icon-whatsapp.svg": 49,
	"./icon-world.svg": 50,
	"./icon-youtube.svg": 51,
	"./logo-cts-global.svg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;